import React from "react"
import styled from "styled-components";
import { rhythm } from "../utils/typography"
import presets from '../utils/presets'

const Span = styled.span`
  color: ${presets.brand};
  font-weight: 400;
  text-transform: capitalize;
`
export default Span



// WEBPACK FOOTER //
// ./src/com/Span.js